(function () {
  var ROOT_SELECTOR = '.c27-contact-page';
  var EMBED_SELECTOR = 'shopify-forms-embed';
  var LINK_PHRASE = 'privacy policy';
  var MAX_ATTEMPTS = 60;

  function getPrivacyHref() {
    var url = new URL('/pages/avada-faqs', window.location.origin);
    url.searchParams.set('view', 'privacy-policy-main');

    var current = new URLSearchParams(window.location.search);
    var previewThemeId = current.get('preview_theme_id');
    if (previewThemeId) {
      url.searchParams.set('preview_theme_id', previewThemeId);
    }

    return url.toString();
  }

  function enhancePrivacyLink(shadowRoot) {
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector('.c27-contact-privacy-link[data-c27-privacy-link-enhanced="true"]')) {
      return true;
    }

    var fieldset = shadowRoot.querySelector('fieldset[name="custom#privacy_agreement"]');
    if (!fieldset) return false;

    var spans = fieldset.querySelectorAll('span[class*="_textBody_"]');

    for (var i = 0; i < spans.length; i++) {
      var el = spans[i];
      var full = (el.textContent || '').trim();
      if (full.toLowerCase().indexOf(LINK_PHRASE) === -1) continue;
      if (el.querySelector('.c27-contact-privacy-link')) continue;

      var idx = full.toLowerCase().indexOf(LINK_PHRASE);
      if (idx === -1) continue;

      var before = full.slice(0, idx);
      var linkText = full.slice(idx, idx + LINK_PHRASE.length);
      var after = full.slice(idx + LINK_PHRASE.length);

      el.textContent = '';
      if (before) el.appendChild(document.createTextNode(before));

      var link = document.createElement('a');
      link.href = getPrivacyHref();
      link.className = 'c27-contact-privacy-link';
      link.setAttribute('data-c27-privacy-link-enhanced', 'true');
      link.textContent = linkText;
      link.style.color = '#000';
      link.style.textDecoration = 'underline';
      link.style.textUnderlineOffset = '2px';
      el.appendChild(link);

      if (after) el.appendChild(document.createTextNode(after));
      return true;
    }

    return false;
  }

  function setupForEmbed(embed) {
    if (!embed || !embed.shadowRoot) return;

    var done = false;

    function tryEnhance() {
      if (done) return true;
      done = enhancePrivacyLink(embed.shadowRoot);
      return done;
    }

    if (tryEnhance()) return;

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (tryEnhance() || attempts >= MAX_ATTEMPTS) {
        window.clearInterval(interval);
      }
    }, 500);

    var observer = new MutationObserver(function () {
      tryEnhance();
    });

    observer.observe(embed.shadowRoot, { childList: true, subtree: true });
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;

    function findAndSetup() {
      var embed = root.querySelector(EMBED_SELECTOR);
      if (embed) {
        setupForEmbed(embed);
        return true;
      }
      return false;
    }

    if (findAndSetup()) return;

    var attempts = 0;
    var interval = window.setInterval(function () {
      attempts += 1;
      if (findAndSetup() || attempts >= MAX_ATTEMPTS) {
        window.clearInterval(interval);
      }
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
